import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from 'theme';
import { InfoText, InfoWrapper } from 'views/declarations/common/DeclarationInformation.styles';

export const Wrapper = styled(InfoWrapper)`
    min-width: 0;
`;

export const LinksList = styled.ul`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 0.8rem;
    margin: 0;
    padding: 0;
    min-width: 0;
    list-style: none;
`;

export const LinksItem = styled.li`
    display: flex;
    align-items: center;
    gap: 0.8rem;
`;

export const DeclarationLink = styled(Link)`
    display: block;
    height: min-content;
`;

export const LinkText = styled(InfoText)`
    display: block;
    // A DUCR can be up to 35 characters, so it gets more room than the default info text.
    /* max-width: 20rem; */
    max-width: 10rem;
    color: ${colors.brand6};

    &:hover {
        text-decoration: underline;
    }
`;
